import React from 'react'
import { Widget } from '@typeform/embed-react'


const Formulario = () => {
     
  return (
    <Widget id="Lh3e0nBk" style={{ width:"100%", height:"600px" }} className="my-form" />
    // <div data-tf-widget="Lh3e0nBk" data-tf-hide-headers data-tf-iframe-props="title=Registration Form" data-tf-medium="snippet"  
    //     style={{width:"100%", height:"600px"}}>
    // </div>
  )
}

export default Formulario